import React from 'react';
import { GuitarMatchProvider } from './context/GuitarMatchContext';
import AppContent from './AppContent';
import { GlobalErrorDisplay } from './components/common/GlobalErrorDisplay'; // Axe 3: Import GlobalErrorDisplay
import { useGlobalError } from './context/hooks/useGlobalError'; // Axe 3: Import useGlobalError

/**
 * GSC Entry Point Wrapper
 * Provides the global state context to the entire application.
 */
export default function App() {
  const { globalError, clearGlobalError } = useGlobalError(); // Axe 3: Use global error hook

  return (
    <GuitarMatchProvider>
      <AppContent />
      {/* Axe 3: Render GlobalErrorDisplay */}
      {globalError && <GlobalErrorDisplay message={globalError} onClose={clearGlobalError} />}
    </GuitarMatchProvider>
  );
}